export const isUserProfileComplete = (user: any) => {
  return (
    user.phoneNumber !== '' &&
    user.phoneNumber !== null &&
    user.graduationYear !== '' &&
    user.graduationYear !== null
  )
}
